import React from 'react';
import { ChevronRight } from 'lucide-react';
interface GpBadgeProps {
  name: string;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}
export function GpBadge({
  name,
  className = '',
  onClick
}: GpBadgeProps) {
  return <button onClick={onClick} className={`group inline-flex items-center gap-0.5 text-gray-700 font-semibold text-sm cursor-pointer hover:text-gray-900 transition-colors ${className}`} data-id="element-200">
      <span className="truncate max-w-full" data-id="element-201">{name}</span>
      <ChevronRight className="w-3 h-3 opacity-0 -ml-0.5 group-hover:opacity-100 group-hover:ml-0 transition-all duration-200 flex-shrink-0 text-gray-400" data-id="element-202" />
    </button>;
}